import { render } from "./slide-9.vue?vue&type=template&id=e39afbc0&scoped=true"
import script from "./slide-9.vue?vue&type=script&lang=js"
export * from "./slide-9.vue?vue&type=script&lang=js"

import "./slide-9.vue?vue&type=style&index=0&id=e39afbc0&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e39afbc0"]])

export default __exports__